import { EEGMontageConfig, EEGMontageConfigJSON } from "../Types/EEGMontageConfig"
import { EEG_LOW_FILTERS, EEG_HIGH_FILTERS, EEG_NOTCH_FILTERS, EEG_SENSITIVITY, ECG_SENSITIVITY } from "../Types/EEG"
import { LayoutWindowId } from "../Types/LayoutWindowId"
import { atomFamily, atom } from "recoil";
import { EEGMontage } from "../Types/EEG";
import { getDefaultAnnotationVisualizationAtom } from "./Visualizations";

type SharedMontageHiddenChannelsKey = {
	dataObjectId: number | null
	montageKey: string
}

export const DEFAULT_EEG_JSON: EEGMontageConfigJSON = {
	viewDuration: 30 * 1000,
	playbackSpeed: 1,
	montage: null,
	LFF: EEG_LOW_FILTERS["1Hz"],
	HFF: EEG_HIGH_FILTERS["70Hz"],
	notch: EEG_NOTCH_FILTERS["60Hz"],
	sensitivityMicroVolts: EEG_SENSITIVITY["7 uV/mm"],
	ecgSensitivity: ECG_SENSITIVITY["7 mm/mV"],
	isLinked: false,
	targetMmPerSecond: undefined,
}

export const eegMontageConfigAtom = atomFamily<EEGMontageConfig, LayoutWindowId>({
	key: "eegMontageConfig",
	default: () => ({
		...getDefaultAnnotationVisualizationAtom(),
		montage: null,
		montageMapping: new Map(),
		LFF: EEG_LOW_FILTERS["1Hz"],
		HFF: EEG_HIGH_FILTERS["70Hz"],
		notch: EEG_NOTCH_FILTERS["60Hz"],
		sensitivityMicroVolts: EEG_SENSITIVITY["7 uV/mm"],
		ecgSensitivity: ECG_SENSITIVITY["7 mm/mV"],
		hiddenChannelKeys: new Set<string>(),
	}),
})

export const eegMontagesAtom = atom<EEGMontage[]>({
	key: "eegMontages",
	default: []
})

export const sharedEEGMontageHiddenChannelsAtom = atomFamily<Set<string>, SharedMontageHiddenChannelsKey>({
	key: "sharedEEGMontageHiddenChannels",
	default: () => new Set<string>(),
})
